import type { Lang } from "./types";

type Dict = Record<string, string>;

// Обращение к сотрудницам — на «вы» с маленькой буквы. Никаких мотивационных похвал.
const RU: Dict = {
  app_title: "KPI магазина",
  header_admin: "Администратор",
  header_maintenance_on: "Профилактика включена",
  header_maintenance_tap: "нажмите, чтобы выключить",

  // Экран сотрудницы
  no_data_title: "За выбранный месяц данных нет",
  no_data_note: "Возможно, вы не работали в этом месяце или данные ещё не опубликованы.",
  prelim_badge: "предварительно",
  prelim_updated: "предварительно · обновлено {at}",

  // Главный экран (этап 3)
  view_label: "Показать:",
  view_all: "📊 Все магазины",
  view_store_prefix: "🏬",
  header_owner_all: "Все магазины",
  header_owner_mode: "режим владельца",
  header_store_mode: "магазин · режим владельца",
  role_pk: "продавец-консультант",
  role_admin: "администратор магазина",
  month_prelim_line: "⏳ предварительно · обновлено {at}",
  no_months_title: "Данных пока нет",
  no_months_note: "Первая публикация из учётной системы появится автоматически.",
  kpi_total_title: "Итоговый KPI за месяц",
  kpi_pct_note: "{pct} от чистых продаж магазина по шкале",
  kpi_floor_note: "к расчёту принято {pct} (минимум)",
  crit_kpi: "KPI:",
  crit_of: "из",
  crit_plan: "план",
  crit_of_plan: "плана",
  crit_points: "баллов",
  crit_base_accrual: "базовое начисление",
  crit_base_extra: "основные + дополнительные",
  crit_info_badge: "справочно",
  shifts_title: "Чеки",
  days_title: "Рабочие дни",
  days_norm: "норма",
  days_planned: "запланировано",
  days_worked: "отработано",
  returns_label: "возвраты",
  checks_label: "чеков от 1000 грн",
  avg_check_label: "средний чек от 1000 грн · план {plan}",
  sick_note: "больничных {days} дн., оплачивается {paid}",
  payout_title: "К выплате",
  payout_sub: "{store} · {month} · предварительно",
  payout_sub_final: "{store} · {month}",
  payout_gross: "Брутто",
  payout_advance: "Аванс",
  payout_deductions: "Вычеты",
  payout_extras: "Доплаты",
  payout_sick: "Больничные",
  payout_vacation: "Отпускные",
  payout_net: "К выплате",
  data_pending_title: "Данные уточняются",
  data_pending_note: "По этому месяцу есть вопросы к данным. Цифры появятся после проверки.",
  data_pending_short: "данные уточняются",
  problems_title: "Пометки панели · сотруднице не видны",
  problems_note: "Сотрудница видит «данные уточняются» вместо цифр.",
  stores_both: "Оба магазина",
  stores_total_note: "к выплате всего {net} · {n} сотрудниц",
  store_title: "Магазин · {label}",
  store_of_plan: "{pct} плана",
  store_from: "из {plan}",
  store_revenue: "выручка",
  store_returns: "возвраты",
  rev_cash: "Деньги",
  rev_terminal: "терминал",
  rev_notes: "наличные",
  rev_cert_sold: "Сертификаты продано · {nom}",
  rev_cert_paid: "Сертификаты отоварено · {nom}",
  rev_overpaid: "Переплата на депозит",
  rev_deposit_paid: "Оплачено депозитом",
  rev_before_returns: "Выручка до возвратов",
  rev_returns: "Возвраты",
  rev_total: "Выручка",
  store_checks: "чеков от 1000 грн",
  store_avg_note: "средний чек от 1000 грн {avg} при плане {plan} · норма {n} смен",
  employees_title: "Сотрудницы",
  total_net: "Итого к выплате",
  checks_all_note: "справочно (не для учёта в KPI), все чеки, включая до 1000 грн: {count} чеков · средний {avg}",

  // Подписи критериев по ключу панели (панель присылает русскую подпись как запасной вариант)
  crit_plan_label: "План магазина",
  crit_shifts_label: "План на смены",
  crit_shiftsInfo_label: "План на смены",
  crit_avg_label: "Средний чек",
  crit_avgOwn_label: "Средний чек сотрудника",
  crit_avgStore_label: "Средний чек магазина",
  crit_service_label: "Обслуживание",
  crit_remarks_label: "Замечания",
  crit_reprimands_label: "Выговоры",
  crit_competence_label: "Компетенции",
  crit_notInitiated_label: "Взыскания не инициированы",
  crit_maxPenalties_label: "Не более 4 взысканий",
  crit_adminRemarks_label: "Замечания админу",

  // Ошибки
  err_loading: "Загрузка…",
  err_access_denied: "Доступ закрыт",
  err_access_admin_note: "Обратитесь к администратору.",
  maintenance_title: "Профилактические работы",
  maintenance_fallback: "Сервис временно недоступен, скоро вернёмся.",
  not_in_telegram_title: "Откройте в Telegram",
  not_in_telegram_note: "KPI магазина работает только внутри Telegram-приложения.",
  not_in_telegram_btn: "Перейти к боту",

  // Админка
  admin_button: "⚙ Админ",
  admin_close: "Закрыть",
  admin_title: "⚙ Админ-панель",
  admin_tab_employees: "Сотрудницы",
  admin_tab_access: "Доступы",
  admin_tab_loads: "Загрузки",
  admin_tab_settings: "Настройки",
  admin_tab_logs: "Логи",

  employees_list_title: "Сотрудницы",
  employees_add_title: "Добавить сотрудницу",
  employees_form_id: "ID сотрудницы из Team Panel (без пробелов)",
  employees_form_name: "Имя для показа в приложении",
  employees_form_submit: "+ Добавить",
  employees_form_invalid_id: "ID: латинские буквы, цифры, точка, двоеточие, _, - (до 64 символов)",
  employees_form_dup_id: "ID уже занят",
  employees_form_dup_name: "Сотрудница с таким именем уже есть",
  employees_form_need_name: "Введите имя",
  employees_archive: "Архивировать",
  employees_restore: "Восстановить",
  employees_archived_label: "(в архиве)",
  employees_archive_confirm: "Архивировать {name}? Доступ в приложение закроется, история данных сохранится.",
  employees_empty: "Сотрудниц пока нет. Добавьте их до первой публикации из панели.",
  employees_edit: "Изменить",
  employees_edit_save: "Сохранить",
  employees_edit_cancel: "Отмена",
  employees_edit_id_note: "Смена ID переносит доступы и загруженные месяцы на новый ID.",

  access_list_title: "Активные привязки",
  access_list_empty: "Привязок пока нет",
  access_add_title: "Привязать номер к сотруднице",
  access_form_phone: "Номер телефона (+380...)",
  access_form_employee: "Сотрудница",
  access_form_submit: "+ Привязать",
  access_form_invalid: "Неверный формат номера. Ожидается +380XXXXXXXXX",
  access_form_dup: "Этот номер уже привязан. Сначала отвяжите.",
  access_form_no_employee: "Сначала добавьте сотрудницу на вкладке «Сотрудницы»",
  access_revoke_confirm: "Отвязать {phone}?",
  access_revoked_label: "(отозван)",

  loads_title: "Публикации из Team Panel",
  loads_empty: "Публикаций ещё не было. Первая ночная публикация придёт из панели автоматически.",
  loads_final: "выплачено",
  loads_prelim: "предварительно",
  loads_employees: "{n} сотрудниц",
  loads_warns: "{n} предупреждений",

  settings_maintenance_title: "Профилактические работы",
  settings_maintenance_help: "Когда включено: всем сотрудницам, кроме админа, показывается страница-заглушка с текстом ниже.",
  settings_maintenance_on: "Включено",
  settings_maintenance_off: "Выключено",
  settings_msg_ru: "Сообщение (RU)",
  settings_msg_uk: "Сообщение (UK)",
  settings_save: "Сохранить",
  settings_saved: "Сохранено",

  logs_title: "Последние входы",
  logs_login_ok: "Вход",
  logs_login_denied: "Отказ",
  logs_unknown_user: "Неизвестный",
  logs_empty: "Пока пусто",
  logs_refresh: "Обновить",

  // Вкладки и рейтинг (этап 4)
  nav_kpi: "KPI",
  nav_rating: "Рейтинг",
  rank_title_avg: "Средний чек",
  rank_sub_avg: "чеки от 1000 грн · внутри магазина",
  rank_title_rps: "Выручка за смену",
  rank_sub_rps: "выручка магазина в смены сотрудницы, в среднем за смену",
  rank_title_sets: "Комплектные продажи",
  rank_sub_sets: "баллов на чек с бюстгальтером · участвуют от {t} чеков",
  rank_sets_rule: "первые трусики к бюстгальтеру — 100, вторые — 50",
  rank_you: "вы",
  rank_place: "{p} место из {n}",
  rank_unit_grn: "грн",
  rank_unit_per_shift: "грн/смену",
  rank_unit_points: "б./чек",
  rank_min_two: "рейтинг появится, когда в магазине будут данные минимум по двум участницам",
  rank_no_data: "данных за этот месяц пока нет",
  rank_not_eligible: "вы не участвуете: {n} чеков с бюстгальтером, нужно от {t}",
  rank_my_score: "ваш балл {s}",
  rank_below_title: "ниже порога",
  rank_bra_checks: "{n} чеков с бюстом",
  away_note: "командировка в {store}: {n} чеков от 1000 грн, средний {avg} грн",
  away_pay_later: "(заработок добавится при выплате KPI)",
  tag_in_kpi: "в KPI",
  tag_not_in_kpi: "не в KPI",
  checks_all_note_plain: "справочно, все чеки, включая до 1000 грн: {count} чеков · средний {avg}",

  // Этап 5: администратор магазина и итоги к выплате
  view_my_card: "👤 Моя карточка",
  header_store_admin: "магазин · администратор",
  store_total_net: "Всего к выплате по магазину",
  final_badge: "выплачено",
  employees_form_view_store: "Видит магазин",
  employees_view_store_none: "только своя карточка",
  employees_view_store_note: "Администратор магазина: карточка магазина и рейтинг с именами. Чужой магазин и чужие суммы не видны.",
  employees_view_store_label: "видит магазин: {label}",
  away_net_note: "без учёта командировочных (будут добавлены при выплате KPI)",
  away_admin_net_note: "без учёта командировочных и администраторской надбавки (будут добавлены при выплате KPI)",
  admin_net_note: "без учёта администраторской надбавки (будет добавлена при выплате KPI)",

  // Пояснения к рейтингам (просьба владельца 28.10.2026: чтобы сотрудницы не задавали вопросов)
  rank_how: "как считается",
  rank_how_common: "Рейтинг только среди сотрудниц вашего магазина, магазины между собой не сравниваются. Денежных выплат за место в рейтинге нет, это статистика за месяц.",
  rank_how_avg: "Сумма ваших чеков от 1000 грн за месяц, делённая на их количество. Чеки до 1000 грн не учитываются, возвраты вычитаются. Чем выше средний чек, тем выше место.",
  rank_how_rps: "Выручка магазина за дни, когда вы были на смене (за вычетом возвратов), делённая на число ваших отработанных смен. Чем выше выручка за смену, тем выше место.",
  rank_how_sets: "Считаются чеки, в которых есть бюстгальтер. За первые трусики к бюстгальтеру 100 баллов, за вторые 50, больше двух на один бюстгальтер не считаются; бюстгальтер без трусиков баллов не даёт. Купальники не учитываются. Показатель — средний балл на чек с бюстгальтером. Участвуют сотрудницы, у которых за месяц от 15 таких чеков. Возврат уменьшает чек, в котором был товар. Чем выше средний балл, тем выше место.",
};

const UK: Dict = {
  app_title: "KPI магазину",
  header_admin: "Адміністратор",
  header_maintenance_on: "Профілактику увімкнено",
  header_maintenance_tap: "натисніть, щоб вимкнути",

  no_data_title: "За обраний місяць даних немає",
  no_data_note: "Можливо, ви не працювали в цьому місяці або дані ще не опубліковано.",
  prelim_badge: "попередньо",
  prelim_updated: "попередньо · оновлено {at}",

  view_label: "Показати:",
  view_all: "📊 Усі магазини",
  view_store_prefix: "🏬",
  header_owner_all: "Усі магазини",
  header_owner_mode: "режим власника",
  header_store_mode: "магазин · режим власника",
  role_pk: "продавець-консультант",
  role_admin: "адміністратор магазину",
  month_prelim_line: "⏳ попередньо · оновлено {at}",
  no_months_title: "Даних поки немає",
  no_months_note: "Перша публікація з облікової системи з'явиться автоматично.",
  kpi_total_title: "Підсумковий KPI за місяць",
  kpi_pct_note: "{pct} від чистих продажів магазину за шкалою",
  kpi_floor_note: "до розрахунку прийнято {pct} (мінімум)",
  crit_kpi: "KPI:",
  crit_of: "із",
  crit_plan: "план",
  crit_of_plan: "плану",
  crit_points: "балів",
  crit_base_accrual: "базове нарахування",
  crit_base_extra: "основні + додаткові",
  crit_info_badge: "довідково",
  shifts_title: "Чеки",
  days_title: "Робочі дні",
  days_norm: "норма",
  days_planned: "заплановано",
  days_worked: "відпрацьовано",
  returns_label: "повернення",
  checks_label: "чеків від 1000 грн",
  avg_check_label: "середній чек від 1000 грн · план {plan}",
  sick_note: "лікарняних {days} дн., оплачується {paid}",
  payout_title: "До виплати",
  payout_sub: "{store} · {month} · попередньо",
  payout_sub_final: "{store} · {month}",
  payout_gross: "Брутто",
  payout_advance: "Аванс",
  payout_deductions: "Утримання",
  payout_extras: "Доплати",
  payout_sick: "Лікарняні",
  payout_vacation: "Відпускні",
  payout_net: "До виплати",
  data_pending_title: "Дані уточнюються",
  data_pending_note: "За цей місяць є питання до даних. Цифри з'являться після перевірки.",
  data_pending_short: "дані уточнюються",
  problems_title: "Позначки панелі · співробітниці не видно",
  problems_note: "Співробітниця бачить «дані уточнюються» замість цифр.",
  stores_both: "Обидва магазини",
  stores_total_note: "до виплати всього {net} · {n} співробітниць",
  store_title: "Магазин · {label}",
  store_of_plan: "{pct} плану",
  store_from: "із {plan}",
  store_revenue: "виручка",
  store_returns: "повернення",
  rev_cash: "Гроші",
  rev_terminal: "термінал",
  rev_notes: "готівка",
  rev_cert_sold: "Сертифікати продано · {nom}",
  rev_cert_paid: "Сертифікати отоварено · {nom}",
  rev_overpaid: "Переплата на депозит",
  rev_deposit_paid: "Оплачено депозитом",
  rev_before_returns: "Виручка до повернень",
  rev_returns: "Повернення",
  rev_total: "Виручка",
  store_checks: "чеків від 1000 грн",
  store_avg_note: "середній чек від 1000 грн {avg} при плані {plan} · норма {n} змін",
  employees_title: "Співробітниці",
  total_net: "Разом до виплати",
  checks_all_note: "довідково (не для обліку в KPI), усі чеки, включно з до 1000 грн: {count} чеків · середній {avg}",

  crit_plan_label: "План магазину",
  crit_shifts_label: "План на зміни",
  crit_shiftsInfo_label: "План на зміни",
  crit_avg_label: "Середній чек",
  crit_avgOwn_label: "Середній чек співробітниці",
  crit_avgStore_label: "Середній чек магазину",
  crit_service_label: "Обслуговування",
  crit_remarks_label: "Зауваження",
  crit_reprimands_label: "Догани",
  crit_competence_label: "Компетенції",
  crit_notInitiated_label: "Стягнення не ініційовано",
  crit_maxPenalties_label: "Не більше 4 стягнень",
  crit_adminRemarks_label: "Зауваження адміну",

  err_loading: "Завантаження…",
  err_access_denied: "Доступ закрито",
  err_access_admin_note: "Зверніться до адміністратора.",
  maintenance_title: "Профілактичні роботи",
  maintenance_fallback: "Сервіс тимчасово недоступний, скоро повернемося.",
  not_in_telegram_title: "Відкрийте в Telegram",
  not_in_telegram_note: "KPI магазину працює лише всередині Telegram-застосунку.",
  not_in_telegram_btn: "Перейти до бота",

  admin_button: "⚙ Адмін",
  admin_close: "Закрити",
  admin_title: "⚙ Адмін-панель",
  admin_tab_employees: "Співробітниці",
  admin_tab_access: "Доступи",
  admin_tab_loads: "Завантаження",
  admin_tab_settings: "Налаштування",
  admin_tab_logs: "Логи",

  employees_list_title: "Співробітниці",
  employees_add_title: "Додати співробітницю",
  employees_form_id: "ID співробітниці з Team Panel (без пробілів)",
  employees_form_name: "Ім'я для показу в застосунку",
  employees_form_submit: "+ Додати",
  employees_form_invalid_id: "ID: латинські літери, цифри, крапка, двокрапка, _, - (до 64 символів)",
  employees_form_dup_id: "ID вже зайнятий",
  employees_form_dup_name: "Співробітниця з таким ім'ям вже є",
  employees_form_need_name: "Введіть ім'я",
  employees_archive: "Архівувати",
  employees_restore: "Відновити",
  employees_archived_label: "(в архіві)",
  employees_archive_confirm: "Архівувати {name}? Доступ до застосунку закриється, історія даних збережеться.",
  employees_empty: "Співробітниць ще немає. Додайте їх до першої публікації з панелі.",
  employees_edit: "Змінити",
  employees_edit_save: "Зберегти",
  employees_edit_cancel: "Скасувати",
  employees_edit_id_note: "Зміна ID переносить доступи та завантажені місяці на новий ID.",

  access_list_title: "Активні прив'язки",
  access_list_empty: "Прив'язок ще немає",
  access_add_title: "Прив'язати номер до співробітниці",
  access_form_phone: "Номер телефону (+380...)",
  access_form_employee: "Співробітниця",
  access_form_submit: "+ Прив'язати",
  access_form_invalid: "Невірний формат номера. Очікується +380XXXXXXXXX",
  access_form_dup: "Цей номер вже прив'язано. Спочатку відв'яжіть.",
  access_form_no_employee: "Спочатку додайте співробітницю на вкладці «Співробітниці»",
  access_revoke_confirm: "Відв'язати {phone}?",
  access_revoked_label: "(відкликано)",

  loads_title: "Публікації з Team Panel",
  loads_empty: "Публікацій ще не було. Перша нічна публікація прийде з панелі автоматично.",
  loads_final: "виплачено",
  loads_prelim: "попередньо",
  loads_employees: "{n} співробітниць",
  loads_warns: "{n} попереджень",

  settings_maintenance_title: "Профілактичні роботи",
  settings_maintenance_help: "Коли увімкнено: усім співробітницям, крім адміна, показується сторінка-заглушка з текстом нижче.",
  settings_maintenance_on: "Увімкнено",
  settings_maintenance_off: "Вимкнено",
  settings_msg_ru: "Повідомлення (RU)",
  settings_msg_uk: "Повідомлення (UK)",
  settings_save: "Зберегти",
  settings_saved: "Збережено",

  logs_title: "Останні входи",
  logs_login_ok: "Вхід",
  logs_login_denied: "Відмова",
  logs_unknown_user: "Невідомий",
  logs_empty: "Поки порожньо",
  logs_refresh: "Оновити",

  nav_kpi: "KPI",
  nav_rating: "Рейтинг",
  rank_title_avg: "Середній чек",
  rank_sub_avg: "чеки від 1000 грн · у межах магазину",
  rank_title_rps: "Виручка за зміну",
  rank_sub_rps: "виручка магазину у зміни співробітниці, у середньому за зміну",
  rank_title_sets: "Комплектні продажі",
  rank_sub_sets: "балів на чек із бюстгальтером · беруть участь від {t} чеків",
  rank_sets_rule: "перші трусики до бюстгальтера — 100, другі — 50",
  rank_you: "ви",
  rank_place: "{p} місце з {n}",
  rank_unit_grn: "грн",
  rank_unit_per_shift: "грн/зміну",
  rank_unit_points: "б./чек",
  rank_min_two: "рейтинг з'явиться, коли в магазині будуть дані щонайменше по двох учасницях",
  rank_no_data: "даних за цей місяць поки немає",
  rank_not_eligible: "ви не берете участі: {n} чеків із бюстгальтером, потрібно від {t}",
  rank_my_score: "ваш бал {s}",
  rank_below_title: "нижче порога",
  rank_bra_checks: "{n} чеків із бюстом",
  away_note: "відрядження до {store}: {n} чеків від 1000 грн, середній {avg} грн",
  away_pay_later: "(заробіток буде додано при виплаті KPI)",
  tag_in_kpi: "у KPI",
  tag_not_in_kpi: "не в KPI",
  checks_all_note_plain: "довідково, усі чеки, включно з до 1000 грн: {count} чеків · середній {avg}",

  view_my_card: "👤 Моя картка",
  header_store_admin: "магазин · адміністратор",
  store_total_net: "Усього до виплати по магазину",
  final_badge: "виплачено",
  employees_form_view_store: "Бачить магазин",
  employees_view_store_none: "лише своя картка",
  employees_view_store_note: "Адміністратор магазину: картка магазину та рейтинг з іменами. Чужий магазин і чужі суми не видно.",
  employees_view_store_label: "бачить магазин: {label}",
  away_net_note: "без урахування відрядних (будуть додані при виплаті KPI)",
  away_admin_net_note: "без урахування відрядних та адміністраторської надбавки (будуть додані при виплаті KPI)",
  admin_net_note: "без урахування адміністраторської надбавки (буде додана при виплаті KPI)",

  rank_how: "як рахується",
  rank_how_common: "Рейтинг лише серед співробітниць вашого магазину, магазини між собою не порівнюються. Грошових виплат за місце в рейтингу немає, це статистика за місяць.",
  rank_how_avg: "Сума ваших чеків від 1000 грн за місяць, поділена на їх кількість. Чеки до 1000 грн не враховуються, повернення віднімаються. Що вищий середній чек, то вище місце.",
  rank_how_rps: "Виручка магазину за дні, коли ви були на зміні (за вирахуванням повернень), поділена на кількість ваших відпрацьованих змін. Що вища виручка за зміну, то вище місце.",
  rank_how_sets: "Рахуються чеки, у яких є бюстгальтер. За перші трусики до бюстгальтера 100 балів, за другі 50, більше двох на один бюстгальтер не рахуються; бюстгальтер без трусиків балів не дає. Купальники не враховуються. Показник — середній бал на чек із бюстгальтером. Беруть участь співробітниці, у яких за місяць від 15 таких чеків. Повернення зменшує чек, у якому був товар. Що вищий середній бал, то вище місце.",
};

export function t(key: string, lang: Lang = "ru", vars?: Record<string, string | number>): string {
  const dict = lang === "uk" ? UK : RU;
  let s = dict[key] ?? RU[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}

/** Ключи, у которых нет украинского перевода (для теста полноты локализации). */
export function missingUk(): string[] {
  return Object.keys(RU).filter(k => !(k in UK));
}

/** Подпись критерия розницы по ключу панели; неизвестный ключ — подпись панели как есть. */
export function criterionLabel(key: string, fallback: string, lang: Lang): string {
  const dict = lang === "uk" ? UK : RU;
  return dict[`crit_${key}_label`] ?? fallback;
}
